module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page",
    attrs: {
      "id": "topHeader"
    }
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "256px"
    },
    attrs: {
      "src": "static/assets/images/logo-light.png",
      "alt": "安阳文旅公共服务中心"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/service"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("全域文旅服务商")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/train"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("红色培训")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/feature"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("特色业务")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("关于我们")])], 1)])])])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer-area section-padding",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexJBetween"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-5"
  }, [_c('div', {
    staticClass: "single-widge-home"
  }, [_c('ul', {
    staticClass: "yjlink"
  }, [_c('li', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/service"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("全域文旅服务商")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/train"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("红色培训")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/feature"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("特色业务")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.flushCom.apply(null, arguments)
      }
    }
  }, [_vm._v("关于我们")])], 1)]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _vm._m(4)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xl-5 col-lg-5"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0"
  }, [_c('img', {
    staticStyle: {
      "width": "250px",
      "margin-bottom": "40px"
    },
    attrs: {
      "src": "/static/assets/images/about/logo-w.png",
      "alt": "安阳古都旅游服务中心"
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("联系电话：0372-3721111 党建培训中心联系人：王主任15903722088")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("工作时间：周一至周五08:30-18:00")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("公司地址：河南省安阳市殷都区安阳殷墟考古文旅小镇办公区4楼")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "border-radius": "6px"
    },
    attrs: {
      "src": "static/assets/images/qr.jpg",
      "alt": "安阳文旅公共服务中心"
    }
  }), _vm._v(" "), _c('p', [_vm._v("关注公众号")]), _vm._v(" "), _c('p', [_vm._v("了解更多资讯")])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "border-radius": "6px"
    },
    attrs: {
      "src": "static/assets/images/xcx.jpg",
      "alt": "安阳文旅公共服务中心"
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫")]), _vm._v(" "), _c('p', [_vm._v("查看更多资讯")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-6",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v("\n          Copyright ©安阳文旅公共服务中心 版权所有ICP备案号："), _c('a', {
    staticStyle: {
      "color": "#8d8d8d"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("豫ICP备19000925号-3")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b363c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 99
// module chunks = 1